<template>
	<div class="cotent_ni">
		<div class="content_top">
			<img :src="category.dingimg" alt="" class="w100">
			<!-- <h3>{{category.cat_name}}</h3> -->
			</div>
			<div class="content_center">
				<div class="container">
					<h3>{{category.cat_name}}</h3>
					<!-- <h4>Hisan offers a range of premium quality weld overlay clad wear plates.</h4> -->
					<p style="margin-bottom: 3vw;">{{category.description}}
			        </p>
                
                </div> 	
            </div>
            <div class="tips3">
                
                <div class="container">
                    <h3>Ассортимент продукций</h3>
                    <ul class="tips3List">
                        <li v-for="(item,index) in tips3List" :key="index"  @click="golink(item.id)">
                            <img :src="item.image" alt="" class="tisp3_img"/>
                            <div class="text_bottom">
                                <div class="tips3_text">
                                    <h4>{{item.title}}</h4>
                                    <p>{{item.overview}}</p>
                                </div>
                                <div class="buttom">
                                    <img src="@/assets/images/index/jt_r.png" alt="" />
                                    <span>Читать далее</span>
                                </div>
                            </div>
                        </li>
                    </ul>	
                </div>
                
            </div>
            <div class="content_center">
            	<div class="container">
                    <h3>Биметаллическое литье CWI</h3>
                    <p>Биметаллические износостойкие изделия представляют собой износостойкий слой высокохромистого белого чугуна, металлургически соединенный с опорной плитой из низкоуглеродистой стали. Белый чугун имеет минимальную твердость 700 единиц по Бринеллю, обеспечивая невероятную износостойкость, а опорная плита из низкоуглеродистой стали легко поддается сварке с минимальной подготовкой и обладает хорошей ударной вязкостью. Обладая превосходными износостойкими характеристиками, они обеспечивают защиту от сильного абразивного износа в самых суровых условиях, продлевая срок службы ковша экскаватора, лопаты, колесного погрузчика, желоба, бункера, воронки или облицовки дробилки. Благодаря разнообразию форм и размеров эти изделия легко устанавливаются на большинство участков с высоким уровнем износа, что способствует сокращению времени обслуживания и простоев.</p>
                    <div class="list_box">
                        <ul>
                            <li>
                                <img src="@/assets/images/bimetal/icon_1.png" alt="">
                                <p>Твердость по Роквеллу</p>
                                <h4>HRC63 (700BHN)</h4>
                            </li>
                            <li>
                                <img src="@/assets/images/bimetal/icon_2.png" alt="">
                                <p>Прочность скрепления</p>
                                <h4>>200<span>МПа</span></h4>
                            </li>
                            <li>
                                <img src="@/assets/images/bimetal/icon_3.png" alt="">
                                <p>Общая ударная вязкость</p>
                                <h4>>140<span>J/cm²</span></h4>
                            </li>
                            
                        </ul>
                    </div>
                    <h3>Твердые вкладыши и заготовки из Ni Hard</h3>
                    <p>Ni Hard - это белый чугун, легированный никелем и хромом, подходящий для низкого ударного и скользящего истирания как в сухих, так и в мокрых условиях эксплуатации. Отливки Ni Hard производятся с твердостью не менее 550 по Бринеллю, твердый белый чугун, содержащий 4% Ni и 2% хрома, относится к группе белых чугунов, которые были легированы для обеспечения высокой устойчивости к абразивному износу в горнодобывающей, фрезерной, строительной, землеройной, асфальтовой, цементной промышленности.<br>
                        Продукция Ni Hard включает в себя вкладыши и заготовки, которые могут быть изготовлены по спецификации заказчика или поставлены из нашего ассортимента складских размеров.
                         </p>
                    <div class="list_box" style="margin-bottom: 4vw;">
                        
                            <ul>
                                <li>
                                    <img src="@/assets/images/nihard/icon_1.png" alt="">
                                    <h4>Твердость</h4>
                                    <p>Твердость по Бринеллю 550+</p>
                                </li>
                                <li>
                                    <img src="@/assets/images/nihard/icon_2.png" alt="">
                                    <h4>Размеры</h4>
                                    <p>Широкий ассортимент и индивидуальные</p>
                                </li>
                                <li>
                                    <img src="@/assets/images/nihard/icon_3.png" alt="">
                                    <h4>Способ установки</h4>
                                    <p>Болт</p>
                                </li>
                                <li>
                                    <img src="@/assets/images/nihard/icon_4.png" alt="">
                                    <h4>Применение</h4>
                                    <p>Желоба, контейнеры, бункеры и т.д.</p>
                                </li>
                                
                            </ul>
                    </div>
                </div>
            </div>        
		<div class="pro_box">
			<div class="container">
				
				<h3>Применение продукции</h3>
				<div class="swiper-container">
				    <div class="swiper-wrapper">
				        <div class="swiper-slide" style="background: #efefef;" v-for="(item,index) in lbList" :key="index">
				           <img class="w100" :src="item.show_img" alt="" >
							
				        </div>
						
				    </div>
				    <div class="swiper-pagination1"></div>
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper';
	import axios from 'axios';
	export default {
		data() {
			return {
				lbList:[
					
				    
				    
				],
                category: {cat_id: "", cat_name: "",description:''},
                
				tips3List:[
					{
						imgsrc:require('@/assets/images/nihard/nihard1.png'),
						name:'NI Hard Liners',
						text:'The product is easy to install, easy to use, widely used, and can be customized according to customer needs.',
					},
					{
						imgsrc:require('@/assets/images/nihard/nihard2.png'),
						name:'NI Hard Blocks',
						text:'The product is easy to install, easy to use, widely used, and can be customized according to customer needs.',
					},
				    
				   
				    
				    
				],
				
			}
			
		},
		methods:{
			golink(id){
				const routeUrl = this.$router.resolve({
					path: "/detail",
					query: { id: id },
				});	
				window.open(routeUrl.href, "_self");
			}
		},
		mounted(){
			var that = this;
			axios({
				method: 'post',
				url:`${this.$apiYf}/anlistapi.php`,
				data: {
					catid:3
				},
				headers: {'Content-Type': 'multipart/form-data'},
			}).then((res) =>{
				console.log(res)
			    that.tips3List = res.data.productc_list;
			});
            axios({
            	method: 'post',
            	url:`${this.$apiYf}/anlicategoryapi.php`,
            	data: {
            		cid:3
            	},
            	headers: {'Content-Type': 'multipart/form-data'},
            }).then((res) =>{
            	console.log(res)
                that.category = res.data.category;
            });
			axios({
				method: 'post',
				url:`${this.$apiYf}/indexlunboapi.php`,
				data: {
					cid:13
				},
				headers: {'Content-Type': 'multipart/form-data'},
			}).then((res) =>{
				console.log(res)
			    that.lbList = res.data.lunboinfo;
			    that.$nextTick(() => {
			        that.kvSwiper = new Swiper ('.swiper-container', {
			            loop: true, 
			            autoplay: {
			                delay: 3000,
			                disableOnInteraction: false,
			            },
			            pagination: {
			                el: '.swiper-pagination1',
			                clickable: true,
			            },
			            navigation: {
			                nextEl: '.swiper-button-next1',
			                prevEl: '.swiper-button-prev1',
			                clickable: true,
			            },
			            centeredSlides: true,
			            slidesPerView: 3,
			            spaceBetween: 30,
			            speed: 500,
			            roundLengths : true, 
			            observer:true,
			            observeParents:true,
			            observeSlideChildren:true,
			            calculateHeight: true,
			            on:{
			                
			                slideChangeTransitionEnd: function(){ 
			                    
			                }  
			              },
			        });
			    })
			});
		}
	
	}
</script>

<style lang="scss">
    .cotent_ni{
        .content_center{
        	width:100%;
        	h3{font-size: 48px;color: #0c4fa2;margin: 4vw 0 2.5vw;text-align: left;
        		position: relative;line-height: 1.8;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #0c4fa2;width: 120px;position: absolute;bottom: 0;left:0;
        		}
        	}
        	h4{
        		font-size: 20px;color:#333;margin-bottom: 1vw;
        	}
        	p{
        		font-size: 16px;line-height: 2;color: #666;
        	}
        }
        .list_box{background: #0c4fa2;padding: 4vw 0;
        	ul{display: flex;flex-wrap: wrap;justify-content: center;
        		li{width: 25%;font-size: 20px;color: #fff;text-align: center;position: relative;
        			&::after{width: 1px;height: 4vw;background: #8dacd3;position: absolute;right:0;top:0;bottom:0;margin: auto;content: "";}
        			&:last-child::after{
        				width:0;
        			}
        			&:hover{
        				img{animation: jump 0.5s ease-in-out infinite;}
        				
        			}
        			p{font-size: 16px;margin-bottom: 0px;color: #fff;}
        			h4{font-size: 18px;margin:16px 0;color: #fff;
        				span{font-size: 16px;}
        			}
        		}
        	}
        }
        
        .tips3{
        	background: #e4f0fa;padding: 5vw 0;
        	h3{
        		font-size: 43px;margin-bottom: 2.5vw;
        		color: #0c4fa2;position: relative;line-height: 1.8;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #0c4fa2;width: 120px;position: absolute;bottom: 0;left:0;
        		}
        	}
        	.tips3List{
        		display: flex;flex-wrap: wrap;
        		li{width: 30%;margin-bottom: 60px;margin-right: 5%;
        			&:nth-child(3n){
        				margin-right: 0;
        			}
        			.tisp3_img{background: #fff;}
        			.text_bottom{background: #fff;padding: 28px;height: 290px;position: relative;
        				.tips3_text{
        					h4{font-size: 24px;color: #000;margin-bottom: 16px;}
        					p{font-size: 14px;color: #666;white-space: pre-wrap;
        					overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 6;-webkit-box-orient: vertical;
        					line-height: 20px;}
        					@media (max-width: 1440px) {
        					    h4{font-size: 20px;}
        						p{font-size: 13px;color: #666;line-height: 20px;}
        						
        					}
        					
        				}
        				.buttom{
        					position: absolute;left: 28px;bottom: 28px;display: flex;cursor: pointer;
        					span{line-height: 26px;color: #0c4fa2;border: solid 2px #0c4fa2;display: inline-block;
        						padding: 0 14px;margin-left: 4px;
        					}
        					&:hover{
        						span{background: #0c4fa2;color: #fff;}
        					}
        				}
        			}
        		}
        	}
        }
        .pro_box{
        	h3{font-size: 48px;color: #0c4fa2;margin: 4vw 0 2.5vw;text-align: left;
        		position: relative;line-height: 1.8;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #0c4fa2;width: 120px;position: absolute;bottom: 0;left:0;
        		}
        	}
        	
        	p{
        		font-size: 16px;line-height: 2;color: #666;
        	}
        	ul{
        		display: flex;justify-content: space-between;flex-wrap: wrap;
        		li{
        			width:49%;padding: 2%;border: solid 1px #858585;margin-bottom: 2.5vw;
        			.pro_text{
        				font-size: 24px;color: #0c4fa2;margin-bottom: 20px;font-weight: bold;
        					p{font-size: 14px;line-height: 1.5;margin-top: 20px;}
        				}
        		
        		}
        	}
        	.swiper-container{margin-bottom: 5vw;}
        	.swiper-pagination1{text-align: center;margin: 1vw 0;
        		.swiper-pagination-bullet{opacity: 0.5;margin: 0 10px;}
        		.swiper-pagination-bullet-active{color: #0c4fa2;opacity: 1;}
        	}	
        	.swiper-button-prev1{width: 121px;height: 51px;background: url(../../assets/images/cco/cco_aal.png) no-repeat center 100%;
        		position: absolute;left: 0;bottom: 5px;
        		&:hover{
        			background: url(../../assets/images/cco/cco_aal1.png) no-repeat center 100%;
        		}
        	}
        	.swiper-button-next1{width: 121px;height: 51px;background: url(../../assets/images/cco/cco_aar.png) no-repeat center 100%;
        		position: absolute;right: 0;bottom: 5px;
        		&:hover{
        			background: url(../../assets/images/cco/cco_aar1.png) no-repeat center 100%;
        		}
        	}
        }
    }
	
</style>